import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { GridComponent, GridDataResult, DataStateChangeEvent,PageChangeEvent,RowClassArgs } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';
import { Subscription, Subject, Observable } from 'rxjs';
import { DateTime } from 'typescript-dotnet-es6/System/Time/DateTime';
import { RvService,UserProfileService,RIAHelper,environment,DownloadService,DefaultsService,GDSCodeService } from '../../../core';
import { AlertComponent, EnumAlertType } from '../../../common/component/alert/alert.component';
import { ActivatedRoute } from '@angular/router';
import { dynamicSort } from '../../../core/dynamic-sort';


@Component({
  selector: 'app-interactive-report',
  templateUrl: './interactive-report.component.html',
  styleUrls: ['./interactive-report.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InteractiveReportComponent implements OnInit {
  @ViewChild(AlertComponent, { static: true }) alertController: AlertComponent;

  constructor(
    private rvService:RvService,
    private downloadService:DownloadService,
    private defaultsService:DefaultsService,
    private route: ActivatedRoute,
    private gdsCodeService: GDSCodeService
  ) { }
  gridView:GridDataResult;
  selectedGDSCode:{text:string, value:number};
  gdsCodeList:Array<{text:string, value:number}>;
  auditResults:GridDataResult;
  public SelectedDate;
  selectedDates:any[];
  selectedRateCell:HTMLTableCellElement;
  auditId:string;
  scheduleId:string;
  numBarRates:number;
  numNegRates:number;
  gridView2TitleHotelName:string;
  gridView2TitleDate:any;
  public SelectedDataItem;
  public state: State = {
    filter:undefined,
    group:[],
    take:undefined};
  public sorted: string = "";
  public stateResultDataset: State = {};
  public sortedResultDataset: string = "";
  ngOnInit() {
    this.auditId = this.route.snapshot.params.auditId;
    this.scheduleId = this.route.snapshot.params.scheduleId;

    //initialize to SABRE, whose GDS ID is 1
    //this is hard coded for now
    let serverGDSCodeList;
    //wait to start until we have the list of gds codes
    this.gdsCodeService.getGDSCodeList(list => {
      serverGDSCodeList = list;
      this.gdsCodeList = this.defaultsService.GetGDSCodes(serverGDSCodeList);
      if(this.gdsCodeList && this.gdsCodeList.length>0) {
        //arbitrarily select the first GDS code in the list of available codes, to start with
        this.gdsSelect(this.gdsCodeList[0].value);
      }
    });
  }

  gridClicked($event) {
    //check className and all parent classNames for doNotShowErrorMessage
    //up until the containing table
    //also do not show the error message for any element inside a th element
    var target = $event.target;
    var showErrorMessage = true;
    if(target && target.parentElement) {
      while(target.parentElement && target.parentElement.tagName!='TABLE') {
        if((target.className && target.className.indexOf('doNotShowErrorMessage')>-1) ||
            target.parentElement.tagName=='TH' || target.tagName=='KENDO-GRID') {
          showErrorMessage = false;
          break;
        }
        target = target.parentElement;
      }
    } else {
      console.log('No parent element');
    }
    if(showErrorMessage) {
      this.alertController.showAlertMessage(5000,"To view details on a given property, click on the cell related to a price or error code you wish to view.",EnumAlertType.Error);
    }
  }

  GetFullReportToExcel($event){
    $event.preventDefault();
    this.downloadService.downloadInteractiveReportToExcel(this.auditId,this.scheduleId, ()=>{})
    .subscribe((data)=>{},
    (err)=> {
      console.log(err);}
    );
  }

  public gdsSelect(gdsId) {
    this.gridView = null;
    this.auditResults = null;

    if(typeof gdsId=='object') {
      gdsId = gdsId.value;
    }

    for(let gdsCode of this.gdsCodeList){
      if(gdsCode.value==gdsId) {
        this.selectedGDSCode = gdsCode;
      }
    }

    let s1 = this.rvService.getAuditAvl_GetDetailReportDataSelectedDates(
      this.auditId, this.scheduleId, (this.selectedGDSCode.text==null?null:this.selectedGDSCode.text.toUpperCase()))
    .subscribe(
      data => {
        this.selectedDates = [...data];
        this.selectedDates = this.selectedDates.map(d =>
        {
          let a =  RIAHelper.ConvertToDate(d);
          return a;
        });
        let s2 = this.rvService.getAuditAvl_BuildHotelListForInteractiveReport(this.state, data, this.auditId, this.scheduleId, this.selectedGDSCode.text.toUpperCase())
        .subscribe(data2 => {
          this.gridView = data2;
        });
      }
    )
  }

  rowCallback(context:RowClassArgs){
    if(context.dataItem.SelecteNegRate) {
      return "yellowRow";
    } else if(context.dataItem.SelectedBARRate){
      return "blueRow"
    } else if(context.dataItem.NegotiatedRate){
      return "lightYellowRow"
    } else if(context.dataItem.BARRate){
      return "lightBlueRow"
    } else {
      return "";
    }
  }

  dateSelect($event, dataItem, i, date){
    this.SelectedDataItem=dataItem;
    this.SelectedDate=date;
    var target = $event.target;
    if(target.className.indexOf('reportCellRight')==-1) {
      target = target.parentElement;
    }
    $event.preventDefault();
    if(this.selectedRateCell) {
      this.selectedRateCell.className = "";
    }
    var targetTd = target.parentElement;

    this.selectedRateCell = targetTd;
    this.selectedRateCell.className = "k-state-selected";

    let displayPrice = dataItem.DateInf[i].DisplayPrice;
    if(displayPrice=='HNA') {
      this.auditResults = null;
    } else {
      this.rvService.getAuditPropertyResult(this.scheduleId, dataItem.AuditPropertyID, date, this.selectedGDSCode.value,this.stateResultDataset)
      .subscribe(data =>{
        this.numBarRates = 0;
        this.numNegRates = 0;
        for(let gds of data.RootResults) {
          if(gds.BARRate) {
            this.numBarRates++;
          }
          if(gds.NegotiatedRate) {
            this.numNegRates++;
          }
        }

        this.auditResults = {data:data.RootResults, total:data.TotalCount};
        let totalCount = data.TotalCount;
        this.gridView2TitleHotelName = dataItem.Name;
        this.gridView2TitleDate = date;
      });
    }
  }
  rateAvailability_downloadInteractiveReportToExcel() {
    this.downloadService.downloadInteractiveReportToExcel(this.auditId,this.scheduleId,()=>{})
      .subscribe((data)=>{},
      (err)=> {
        console.log(err);
      });
  }
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;

    this.sorted = "";
    this.sorted = (state.sort.find(e =>  e.dir==='asc' ||e.dir=='desc' ) || {'field':''}).field;
    //check the field name against the list of field names to be sorted as numbers, then pass sort type to dynamicSort
    var sort = state.sort[0];
    var sortFn = dynamicSort(sort.field, sort.dir);
    this.gridView.data.sort(sortFn);
  }
  public dataStateChangeDS(state: DataStateChangeEvent): void {
    this.stateResultDataset = state;
    this.sortedResultDataset = "";
    this.sortedResultDataset = (state.sort.find(e =>  e.dir==='asc' ||e.dir=='desc' ) || {'field':''}).field;
    this.rvService.getAuditPropertyResult(this.scheduleId,this.SelectedDataItem.AuditPropertyID, this.SelectedDate, this.selectedGDSCode.value,this.stateResultDataset)
    .subscribe(data =>{
      this.numBarRates = 0;
      this.numNegRates = 0;
      for(let gds of data.RootResults) {
        if(gds.BARRate) {
          this.numBarRates++;
        }
        if(gds.NegotiatedRate) {
          this.numNegRates++;
        }
      }
      this.auditResults = {data:data.RootResults, total:data.TotalCount};
      let totalCount = data.TotalCount;
      this.gridView2TitleHotelName = this.SelectedDataItem.Name;
      this.gridView2TitleDate = this.SelectedDate;
    });
  }


}
